import { ContentLink, EpiContent, EpiLink } from '@api/types';
import { Button, MegaMenu, MultilevelMenu, MultilevelMenuProvider } from '@components';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { colors } from '@themes/colors';

// TYPES
//-------
export type MegaMenuBlockProps = {
  buttonLabel: string;
  content?: EpiContent;
  contentLink?: ContentLink;
  primaryLinks?: EpiLink[];
};

// COMPONENTS
//------------
export const MegaMenuBlock = ({
  content = [],
  buttonLabel,
  contentLink,
  primaryLinks,
}: MegaMenuBlockProps) => {
  const id = contentLink?.guidValue ?? '';
  const header = (
    <Button
      variant='text'
      endIcon={<KeyboardArrowDownIcon />}
      sx={{
        color: colors.text.primary,
        fontWeight: '500 !important',
        '&:hover': {
          backgroundColor: 'transparent !important',
        },
        padding: '0 !important',
      }}
      disableRipple
      disableFocusRipple
    >
      {buttonLabel}
    </Button>
  );

  return (
    <MultilevelMenuProvider>
      <MegaMenu id={id} header={header}>
        <MultilevelMenu id={id} content={content} links={primaryLinks} />
      </MegaMenu>
    </MultilevelMenuProvider>
  );
};
